import Footer from './Footer'
import CourseMenu from './CourseMenu'
import CourseHeader from './CourseHeader'
import Header from './Header'
import Head from 'next/head';
import { ReactElement } from 'react';

function LayoutBlog({ children, title, description, image }: any) {

    return (
        <>
            <Head>
                {title && <title>{title}</title>}
                {description && <meta name="description" content={description} />}
                <meta property="og:type" content="article" />
                {description && <meta property="og:title" content={description}></meta>}
                {image && <meta property="og:image" content={image} />}
            </Head>
            <Header />
            <div className="prose max-w-3xl mx-auto px-3 py-8">
                <nav className='mb-5 text-sm text-gray-500'>
                    <a href="/articles" className="text-blue-600 hover:text-blue-800 transition-colors duration-200">Articles</a>
                    <span className="mx-2">/</span>
                    <span className="text-gray-700">{title.substring(0, 50)}{title.length > 50 && '...'}</span>
                </nav>
                {children}
            </div>

            <Footer />
        </>
    )
}

export default LayoutBlog;